export function navigationDocumentType(
    workspaceLocalStorage: string,
    organizationLocalStorage: string,
    nameOrg: string
) {
    if(workspaceLocalStorage != "" && workspaceLocalStorage != null && organizationLocalStorage == nameOrg)
        return "/" +organizationLocalStorage+"/wsallowed/" + workspaceLocalStorage 
    return "/" + nameOrg + "/Workspace/"
}